import {
  Disclosure,
  DisclosurePanel,
  DisclosureButton,
} from '@headlessui/react';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface AccordionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  wrapperClassName?: string;
  buttonClassName?: string;
  panelClassName?: string;
  action?: React.ReactNode;
}

export function Accordion({
  title,
  subtitle,
  children,
  wrapperClassName,
  buttonClassName,
  panelClassName,
  action,
}: AccordionProps) {
  return (
    <Disclosure
      as="div"
      className={twMerge([
        'border-gray-20 w-full rounded-md border',
        wrapperClassName,
      ])}
    >
      <dt>
        <DisclosureButton
          className={twMerge([
            'group flex w-full items-center justify-between text-left text-gray-900',
            'bg-gray-50 px-2 py-2',
            'hover:bg-gray-100',
            'data-[open]:bg-gray-200',
            'rounded-md data-[open]:rounded-b-none',
            buttonClassName,
          ])}
        >
          <div className="flex flex-row items-center justify-center gap-2">
            <span className="text-base font-semibold">{title}</span>
            {subtitle && (
              <span className="text-sm text-gray-600">{subtitle}</span>
            )}
          </div>
          <span className="ml-6 flex h-7 items-center">
            <div className="flex flex-row items-center justify-start gap-3">
              {action}
              <PlusIcon
                aria-hidden="true"
                className="size-6 group-data-[open]:hidden"
              />
              <MinusIcon
                aria-hidden="true"
                className="size-6 group-[:not([data-open])]:hidden"
              />
            </div>
          </span>
        </DisclosureButton>
      </dt>
      <DisclosurePanel as="dd">
        <div
          className={twMerge([
            'flex w-full flex-col items-start justify-start gap-2 px-2 py-2',
            panelClassName,
          ])}
        >
          {children}
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
